import './4starrestaurantgroup2/style';
import FormStructure from './4starrestaurantgroup2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js